<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Inconsistencias de traslados por rango de fechas
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <label>Fecha inicio</label>
              <input
                v-model="current.fecha_inicio"
                class="form-control"
                type="date"
              />
            </div>
            <div class="col-6">
              <label>Fecha fin</label>
              <input
                v-model="current.fecha_fin"
                class="form-control"
                type="date"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <div
                v-if="current.fecha_inicio && current.fecha_fin"
                class="dropdown"
              >
                <button
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  class="btn btn-info btn-block dropdown-toggle"
                  aria-expanded="false"
                >
                  <i class="fas fa-download"></i>
                  Generar Reporte
                </button>
                <div
                  aria-labelledby="dropdownMenuButton"
                  class="dropdown-menu btn-block"
                  x-placement="bottom-start"
                  style="
                    position: absolute;
                    transform: translate3d(0px, 30px, 0px);
                    top: 0px;
                    left: 0px;
                    will-change: transform;
                  "
                >
                  <a
                    @click="GenerarReporteXls(current)"
                    class="dropdown-item btn-block text-center"
                    ><i class="far fa-file-alt"></i> - XLS</a
                  >
                  <a
                    @click="GenerarReporte(current)"
                    class="dropdown-item btn-block text-center"
                    ><i class="far fa-file-alt"></i> - PDF</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_format=pdf&report_name=wms/tarima/inconsistencias_por_rango_fecha/inconsistencias_por_rango_fecha_subreport.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}`
      );
      current.fecha_fin = "";
      current.fecha_inicio = "";
    },
    GenerarReporteXls(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_format=xls&report_name=wms/tarima/inconsistencias_por_rango_fecha/inconsistencias_por_rango_fecha_subreport.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}`
      );
      current.fecha_fin = "";
      current.fecha_inicio = "";
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current.sku).then((response) => {
        self.current = response.data;
      });
      self.showModalAddPrecios();
    },

    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ProductosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalAddPrecios() {
      let self = this;
      $("#modalAddPrecios").modal();
    },
  },
};
</script>